"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WarningSmallIcon = function WarningSmallIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningSmallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "modal": "DeleteAssetModal__modal__fskZE",
  "header": "DeleteAssetModal__header__YstUx",
  "body": "DeleteAssetModal__body__2lJ_d",
  "footer": "DeleteAssetModal__footer__3EAoC",
  "title": "DeleteAssetModal__title__1dr9Z",
  "text": "DeleteAssetModal__text__FGBfZ",
  "icon": "DeleteAssetModal__icon__h8VY1",
  "warning": "DeleteAssetModal__warning__F0gIV",
  "message": "DeleteAssetModal__message__3wWeG",
  "dependents": "DeleteAssetModal__dependents__3tWFG",
  "subtitle": "DeleteAssetModal__subtitle__2-sRR",
  "versions-container": "DeleteAssetModal__versions-container__1_VSg",
  "versionsContainer": "DeleteAssetModal__versions-container__1_VSg",
  "open-icon": "DeleteAssetModal__open-icon__X5xPP",
  "openIcon": "DeleteAssetModal__open-icon__X5xPP",
  "modal-lg": "DeleteAssetModal__modal-lg__-37XX",
  "modalLg": "DeleteAssetModal__modal-lg__-37XX"
}; 
require('./DeleteAssetModal.css');
var DeleteHeader = exports.DeleteHeader = function DeleteHeader(_ref) {
  var hasDeleteError = _ref.hasDeleteError,
    headerTitle = _ref.headerTitle,
    isLastVersion = _ref.isLastVersion,
    canDelete = _ref.canDelete,
    labelId = _ref.labelId;
  function getHeaderTitle() {
    if (hasDeleteError) {
      return 'Unable to delete - Dependent asset';
    }
    if (headerTitle) {
      return headerTitle;
    }
    return isLastVersion ? 'Delete asset' : 'Delete asset version';
  }
  return /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title
  }, canDelete ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(TrashIcon, null)) : null, !canDelete ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(WarningSmallIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
    id: labelId,
    className: styles.text,
    "data-test-id": "delete-asset-title"
  }, getHeaderTitle()));
};
//# sourceMappingURL=DeleteHeader.js.map